// Field rules for the application forms. They mirror the checks the server makes on
// submit (applicationProblems in backend/routes/applicationRoutes.js), so a mistake
// shows under its own field while the user types instead of in one long list at the end.
const required = (label) => (v) =>
  (v !== null && v !== undefined && String(v).trim() !== "") || `${label} is required`;

const matches = (pattern, message) => (v) =>
  v === null || v === undefined || String(v) === "" || pattern.test(String(v)) || message;

const LETTERS = /^[a-zA-Z\s\-.]+$/;
const LETTERS_MSG = "Only letters, spaces, hyphens and dots are allowed";
const ALNUM = /^[a-zA-Z0-9\s\-,]+$/;
const ALNUM_MSG = "Only letters, numbers, spaces, hyphens and commas are allowed";

export const applicationRules = {
  applicantName: [required("Applicant name"), matches(ALNUM, ALNUM_MSG)],
  orgName: [required("Name of institution"), matches(LETTERS, LETTERS_MSG)],
  personName: [required("Name"), matches(LETTERS, LETTERS_MSG)],
  designation: [required("Designation"), matches(ALNUM, ALNUM_MSG)],
  orgAddress: [required("Address"), matches(ALNUM, ALNUM_MSG)],
  address: [required("Address")],
  landline: [
    required("Landline number"),
    matches(/^\d{11}$/, "Landline must be 11 digits (with STD code)"),
  ],
  telephone: [
    required("Telephone"),
    matches(/^\d{10}$/, "Telephone must be 10 digits"),
  ],
};

// A camp takes up to its maximum number of participants (the group leaders are in that
// list too), plus a few additional names.
export const EXTRA_MEMBERS = 5;

export default {
  computed: {
    appRules() {
      return applicationRules;
    },
    memberLimit() {
      return Number(this.campview && this.campview.totalMembers) || 0;
    },
    extraMembers() {
      return EXTRA_MEMBERS;
    },
    memberHardLimit() {
      return this.memberLimit ? this.memberLimit + EXTRA_MEMBERS : 0;
    },
  },
  methods: {
    memberCapReached(count) {
      return this.memberHardLimit > 0 && count >= this.memberHardLimit;
    },
    // Says why nobody else can be added, when the cap is reached.
    notifyMemberCap() {
      this.msg = `This camp takes up to ${this.memberLimit} participants, plus ${EXTRA_MEMBERS} additional names (${this.memberHardLimit} in all).`;
      this.showSnackBar = true;
    },
  },
};
